const box = document.querySelector('#box-categories')
const btn_more = document.querySelector('#btn-more-categories')
const btn_less = document.querySelector('#btn-less-categories')

if (!btn_more) {
  return
}

btn_more.addEventListener('click', () => {
  box.setAttribute('data-open', 'true')
  btn_more.classList.add('hidden')
})

btn_less.addEventListener('click', () => {
  box.setAttribute('data-open', 'false')
  btn_more.classList.remove('hidden')
})
